import {styled} from "@mui/material/styles"
import Typography from "@mui/material/Typography"

const StandardShowFiltersText = styled(Typography, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{
    disabled?: boolean
    $isSecondary?: boolean
    $isclipped?: boolean
    component?: string
    row?: boolean
}>`
    white-space: normal;
    text-align: left;
    opacity: ${({disabled}) => (disabled ? 0.4 : 1)};
    display: flex;
    flex-direction: ${props => (props.row ? "row" : "column")};
    max-width: 100%;
    align-items: center;
    letter-spacing: 0.0075rem;

    span:nth-of-type(2) {
        color: ${({theme}) => theme.colours.text.muted};
        font-weight: ${({theme}) => theme.colours.font.primary.regular.weight};
    }

    ${({$isSecondary, theme}) =>
        $isSecondary &&
        `white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${theme.colours.text.muted};`}
`

export default StandardShowFiltersText
